
import dayjs from 'dayjs';
import utc from 'dayjs-plugin-utc';

dayjs.extend(utc);


export default function t(s) {
  const date = dayjs(s).utc().startOf('day');
  const iso = date.toISOString();
  console.log('midnight (ISO) of ', s, 'is', iso);
  return iso;
}
